import urls from "@/utils/urls/urls";


export default async function getDynamicContent(queryUrl: string) {
  try {
    const res = await fetch(urls.api + "pages/get-content?url=" + queryUrl, {
      method: "GET",
      cache: "no-cache",
    });

    const result = await res.json();

    if (result?.status !== "OK") {
      return {};
    }

    return result?.data;
  } catch (err) {
    // console.log(err);
    return {};
  }
}
